export const isValidMoneyAmountInputDraft = (value: string): boolean =>
  value === "" || /^\d*([.,]\d*)?$/.test(value);

export const formatMoneyAmountInputValue = (
  amountMinor: number | null | undefined,
): string => {
  if (amountMinor === null || amountMinor === undefined) {
    return "";
  }
  const major = amountMinor / 100;
  const fixed = major.toFixed(2);
  return fixed.replace(/\.?0+$/, "") || "0";
};

export const parseMoneyAmountInput = (value: string): number | null => {
  const trimmed = value.trim();
  if (trimmed === "") {
    return null;
  }
  const normalized = trimmed.replace(",", ".");
  const parsed = Number(normalized);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return null;
  }
  return parsed;
};

export const moneyAmountInputToMinor = (value: string): number | null => {
  const major = parseMoneyAmountInput(value);
  if (major === null) {
    return null;
  }
  return Math.round(major * 100);
};
